import type { ReactNode } from "react";
import { MERGED_SERIES_KEY, type EvalResultSeries } from "./evalCompareModel";
import { MERGED_RAINBOW_BACKGROUND } from "./MergedSeriesGradient";
import styles from "./SeriesSwatch.module.css";

// 시리즈 하나를 가리키는 색 사각형이다. 범례와 비교 표 헤더가 같은 모양을 써야 색 하나로 두
// 자리를 연결한다. 그래서 크기 mode 를 두지 않는다. 색은 데이터 팔레트가 정한다.
// merged 만 무지개 그라디언트로 구분한다. merged 의 색은 슬롯 0 과 같아서 채움만으로는
// 구분할 수 없다.
export function SeriesSwatch({ item }: { item: EvalResultSeries }): ReactNode {
  return (
    <span
      className={styles.swatch}
      style={{
        backgroundColor: item.color,
        backgroundImage: item.key === MERGED_SERIES_KEY ? MERGED_RAINBOW_BACKGROUND : undefined,
      }}
      aria-hidden
    />
  );
}
